import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BzButton } from '../components';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { TOAST_TIMER } from '../utils/global_variables';
import { toastConfig } from '../redux/actions/toast';

const BzToastMessage = ({ btnClickHandler = () => {} }) => {

    const dispatch = useDispatch();

    const { toast } = useSelector(state => state?.toast);

    useEffect(() => {
        if (toast?.autoDismiss) {
            const objTimeout = setTimeout(() => {
                dispatch(toastConfig({}));
            }, toast?.timer || TOAST_TIMER);
            return () => clearTimeout(objTimeout);
        } else { }
    }, [dispatch, toast]);


    return (
        <>
            {
                /** 09/01/2024 Ajitesh: TOAST MESSAGE LAYOUT IF CALLED FOR EDIS  */
                toast?.show &&
                <div className= {toast?.backdrop ? 'toastmessage-backdrop': null}>
                <Container fluid className='toastmessage-card toastmessage-card-md'>
                    { toast?.edisFlag ? 
                    ( 
                        <Row className='g-0'>
                            <Col md='auto' className='d-flex justify-content-center align-items-start me-2'>
                                <div className='icon-28 icon-edis-authentication'></div>
                            </Col>
                            <Col>
                                <Row className='g-0 mb-2'>
                                    <Col md={11} className='d-flex justify-content-start align-self-center'>
                                        <div className='font-regular font-size4 toastmessage-textcolor text-wrap'>eDIS Permission</div>
                                    </Col>
                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                        <div className='icon-14 icon-close icon-light' onClick={() => dispatch(toastConfig({ show: false }))}></div>
                                    </Col>
                                </Row>
                                <Row className='g-0 align-items-start'>                                            
                                    <Col md={7} className='d-flex justify-content-start align-items-center'>
                                        <div className='font-regular font-size2 toastmessage-textcolor'>{toast?.message}</div> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                    </Col>
                                    <Col md='auto' className='d-flex justify-content-end align-items-center ms-auto'>
                                        {
                                            toast?.button?.length > 0 ?
                                                <div className='d-flex'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                                    {
                                                        toast?.button.map((btn, index) =>
                                                            <BzButton className={`btn btn-sm text-truncate text-capitalize ${btn?.className}`} key={index} onClick={btn?.onClickHandler ? btn?.onClickHandler?.bind(this, btn) : btnClickHandler?.bind(this, btn?.type)} type="button" disabled={btn?.bIsDisabled}>
                                                                {btn?.btnName}
                                                            </BzButton>
                                                        )
                                                    }
                                                </div> : null
                                        }
                                    </Col>               
                                </Row>
                                <Row className='g-0 mt-2'>
                                    <Col className='d-flex justify-content-end align-items-center'>
                                        <div className='font-regular font-size1 toastmessage-textcolor text-wrap'>You can access this later via Hamburger menu (<div className='icon-10 icon-hamburger icon-light'></div>) &gt; eDIS permission OR Portfolio</div>
                                    </Col>                                
                                </Row>
                            </Col>
                        </Row>
                    ) : 
                    (
                        <Row className='g-0'>                                            
                            <Col md={8} className='d-flex justify-content-start align-items-center'>
                                <div className='font-regular font-size3 toastmessage-textcolor text-wrap'>{toast?.message}</div> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                            </Col>
                            <Col md={4} className='d-flex justify-content-end align-items-center'>
                                {
                                    toast?.button?.length > 0 ?
                                        <div className='d-flex'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                            {
                                                toast?.button.map((btn, index) =>
                                                    <BzButton className={`btn btn-md text-truncate text-capitalize ${btn?.className}`} key={index} onClick={btn?.onClickHandler ? btn?.onClickHandler?.bind(this, btn) : btnClickHandler?.bind(this, btn?.type)} type="button" disabled={btn?.bIsDisabled}>
                                                        {btn?.btnName}
                                                    </BzButton>
                                                )
                                            }
                                        </div> : null
                                }
                            </Col>               
                        </Row>
                    )}
                </Container>
                </div>
        }
        </>
    );
};


export default memo(BzToastMessage);

BzToastMessage.propTypes = {
    btnClickHandler: PropTypes.func,
};